<abb-header />
<mat-sidenav-container autosize class="flex-1 !flex w-full !text-inherit">
    <mat-sidenav #sidenav id="sidenav" mode="side" opened [attr.open]="!isCollapsed" [ngClass]="{'!w-64': !isCollapsed}" class="!z-above-side-panel-backdrop">
        <div class="flex flex-col items-center justify-between h-full">
        <mat-nav-list class="!p-0 w-full">
            @for(page of PAGES; track page){
                @if(authorized(page)) {
                    <a mat-list-item [routerLink]="page.link" routerLinkActive="active" class="!rounded-none !h-16" [ngClass]="{'border-l-4 border-l-abb-primary': activeRoute?.includes(page.link)}">
                        <span class="flex items-center gap-4 p-3 text-abb-font/60 font-medium tracking-normal" [ngClass]="{'!text-abb-primary': activeRoute?.includes(page.link)}">
                            <abb-icon [ngClass]="{'rotate-90': page?.icon?.rotateIcon}" [name]="page.icon.name" size="large"></abb-icon>
                            @if(!isCollapsed) {
                                <span>{{page.title | t}}</span>
                            }
                        </span>
                    </a>
                }
            }
        </mat-nav-list>
        <abb-button class="m-4 py-2" variant="circular" size="36" (onclick)="toggleMenu()" [icon]="isCollapsed ? 'mat/chevron_right' : 'mat/chevron_left'"/>
        </div>
    </mat-sidenav>
    <mat-sidenav-content id="sidenav-content" class="pt-6 !flex flex-1">
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>